import FJMediaStore from "./FJMediaStore";
import FJMedia from "./FJMedia";
import FJUtil from "../util/FJUtil";
import FJConfig from "../config/FJConfig";

/**
 * @class FJCloudStore
 * @classdesc 媒体库管理器
 */
let FJCloudStore = (function () {
  let _doneMedia = [];        // 已同步到云端的媒体列表
  let _uploadingMedia = null; // 正在上传的媒体

  return {
    /**
     * 序列化媒体库内容
     */
    encode: function () {
      return [..._doneMedia];
    },
    /**
     * @desc 读取媒体数据
     * @param {Array} data - 和encode的数据结构一样
     */
    decode: function (data) {
      if (!data)
        return;
      data.forEach(item => {
        _doneMedia.push(item);
      });

      this.updateAllMediaStatus();
    },

    getDoneMedia: function () {
      return [..._doneMedia]
    },

    /**
     * 更新所有本地媒体素材的云存储状态，主要是判断媒体是否已存在云端
     */
    updateAllMediaStatus: function () {
      let media = FJMediaStore.getMediasWithType(FJMedia.MediaFromType().LOCAL);
      media.forEach(item => {
        if (_doneMedia.includes(item.id)) {
          item.setCloudStatus(FJMedia.CLOUD_STATUS().DONE);
        }
      });
    },

    /**
     * 更新素材的云存储状态
     * 如果更新为已上传状态，则需要同时更新已同步列表
     * @param media
     * @param status
     */
    updateMediaStatus: function (media, status) {
      media.setCloudStatus(status);
      if (status === FJMedia.CLOUD_STATUS().DONE && !_doneMedia.includes(media.id)) {
        _doneMedia.push(media.id);
      }
    },

    /**
     * @description 删除在记录在doneMedia中的值
     * @param id
     */
    deleteDoneMediaById: function (id) {
      let newDoneMedia = [];
      _doneMedia.forEach(m => {
        if (m !== id) {
          newDoneMedia.push(m);
        }
      });
      _doneMedia = [...newDoneMedia];
    },

    /**
     * @description 设置需要云同步的资源为 等待上传 状态
     * @returns {null}
     */
    setMediaWaitingUpload: function () {
      let mediaList = FJMediaStore.getMediasWithType(FJMedia.MediaFromType().LOCAL);
      mediaList.forEach(media => {
        if (media.getStatus() !== FJMedia.MediaStatus().LINK && (media.cloudStatus === FJMedia.CLOUD_STATUS().UNDONE || media.cloudStatus === FJMedia.CLOUD_STATUS().FAILED))
          media.setCloudStatus(FJMedia.CLOUD_STATUS().WAITING)
      });
    },

    /**
     * 获取下一个上传的媒体素材
     * @returns {null}
     */
    getNextMediaForUpload: function () {
      if (_uploadingMedia)
        return null;

      let localMedias = FJMediaStore.getMediasWithType(FJMedia.MediaFromType().LOCAL);
      _uploadingMedia = localMedias.find(item => item.cloudStatus === FJMedia.CLOUD_STATUS().WAITING);
      return _uploadingMedia;
    },

    /**
     * 媒体上传结束，更新媒体状态，并记录上传失败的媒体
     * @param success
     */
    mediaUploadEnd: function (success) {
      if (!_uploadingMedia)
        return;

      if (success) {
        _doneMedia.push(_uploadingMedia.id); // 记录为上传成功的媒体素材
        _uploadingMedia.setCloudStatus(FJMedia.CLOUD_STATUS().DONE);
      } else {
        _uploadingMedia.setCloudStatus(FJMedia.CLOUD_STATUS().FAILED);
      }
      _uploadingMedia = null;
    },

    /**
     * 获取所有本地媒体的云同步状态
     * @returns {{uploading: (*|null), done: *[], undone: *[]}}
     */
    getMediaListCloudStatus: function () {
      let media = FJMediaStore.getMediasWithType(FJMedia.MediaFromType().LOCAL);
      let done = [];
      let undone = [];
      let failed = [];

      media.forEach(item => {
        if (item.cloudStatus === FJMedia.CLOUD_STATUS().DONE)
          done.push(item.id);
        else if (item.cloudStatus === FJMedia.CLOUD_STATUS().UNDONE)
          undone.push(item.id);
        else if (item.cloudStatus === FJMedia.CLOUD_STATUS().FAILED)
          failed.push(item.id);
      });
      return {
        done: done,
        undone: undone,
        failed: failed,
        uploading: _uploadingMedia ? _uploadingMedia.id : null
      }
    },

    /**
     * @description 设置所有需要云同步的文件失败
     */
    setUndoneFail: function () {
      _uploadingMedia = null;
      let media = FJMediaStore.getMediasWithType(FJMedia.MediaFromType().LOCAL);
      media.forEach(item => {
        if (item.cloudStatus === FJMedia.CLOUD_STATUS().UNDONE || item.cloudStatus === FJMedia.CLOUD_STATUS().UPLOADING || item.cloudStatus === FJMedia.CLOUD_STATUS().WAITING) {
          item.setCloudStatus(FJMedia.CLOUD_STATUS().FAILED);
          item.setUploadProgress(0);
        }
      });
    },

    /**
     * @description 设置当前云同步的media的上传进度
     * @param progress
     */
    setMediaUploadIngProgress: function (progress) {
      if (!_uploadingMedia)
        return;
      _uploadingMedia.setUploadProgress(progress);
    },

    /**
     * @description 通过id判断是否是正在上传的media
     * @param id
     * @returns {boolean}
     */
    checkMediaIsUploadIngById: function (id) {
      if (!_uploadingMedia) {
        return false;
      }
      return _uploadingMedia.id === id
    },

    /**
     * @description 是否是已经上传到云端的media
     * @param id
     * @returns {boolean}
     */
    isCloudMedia: function (id) {
      return _doneMedia.indexOf(id) !== -1
    },

    /**
     * @description 通过media的id获取他的URL
     * @param id
     * @returns {*|string}
     */
    getMediaUrlById: function (id) {
      let media = FJMediaStore.getMediaById(id);
      return FJConfig.mediaCacheUrl + '/' + FJUtil.getS3Key(media);
    },

    clearUploadMedia: function () {
      _uploadingMedia = null;
    },

    /**
     * @description 返回正在上传meida
     * @returns {*}
     */
    getUploadingMedia: function () {
      return _uploadingMedia;
    }
  }
})();

export default FJCloudStore;
